export enum MESSAGE_REPEAT_TYPE {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export enum MESSAGE_EMAIL_PROVIDER_AUTH_TYPE {
  NO = 'no',
  PLAIN = 'plain',
  MD5 = 'md5',
}

export enum DELIVERY_STATUS {
  READY = 0,
  SENDING = 1,
  SENT = 2,
  SENT_ERROR = 3,
  FORCED_STOP = 4,
}

export enum CHANGE_LOG_ACTION_TYPE {
  CREATED = 0,
  APPROVED = 1,
  EDITED = 2,
  STATE = 3,
}

export enum PUSH_SCHEDULED_DELIVERY {
  DEVICE_LOCALTIME = 0,
  TIMEZONE_USER = 1,
}

export enum MESSAGE_EVENT {
  IMPRESSION = 'impression',
  CLICK = 'click',
  OPEN = 'open',
  DISMISSED_CLICK = 'dismissed_click',
}

export enum MESSAGE_TYPE {
  ADBALL = 'adball',
  BANNER = 'banner',
  COUPON = 'coupon',
  DEFAULT = 'default',
  DYNAMICTAB = 'dynamictab',
  EMAIL = 'email',
  NATIVEAD = 'native_ad',
  PUSH = 'push',
  STARTVIEW = 'startview',
  STRIP = 'strip',
  TEST_AB = 'test_ab',
  BLANK = 'blank',
}

export const MESSAGE_TYPES_OUTAPP = [MESSAGE_TYPE.EMAIL, MESSAGE_TYPE.PUSH];
export const MESSAGE_TYPES_INAPP = [
  MESSAGE_TYPE.ADBALL,
  MESSAGE_TYPE.BANNER,
  MESSAGE_TYPE.COUPON,
  MESSAGE_TYPE.DYNAMICTAB,
  MESSAGE_TYPE.NATIVEAD,
  MESSAGE_TYPE.STARTVIEW,
  MESSAGE_TYPE.STRIP,
];

export enum MESSAGE_CAMPAIGN_TYPE {
  CLASSIC = 0,
  AUTOMATIC_RULE,
  AUTOMATIC_JOURNEY,
}

export enum MESSAGE_USER_TYPE {
  OWNER = 'owner',
  RESPONSIBLE = 'responsible',
}

export enum MESSAGE_OPEN_LOCATION {
  IN_APP = 0,
  DEFAULT_BROWSER,
}

export enum MESSAGE_POSITION {
  TOP = 0,
  BOTTOM,
}
export enum MESSAGE_VERTICAL_LOCATION {
  TOP = 0,
  MIDDLE,
  BOTTOM,
}
export enum MESSAGE_HORIZONTAL_LOCATION {
  LEFT = 0,
  RIGHT,
}

export enum MESSAGE_STATUS {
  ACTIVE = 'Active',
  APPROVED = 'Approved',
  DELETED = 'Deleted',
  DRAFT = 'Draft',
  FINISHED = 'Finished',
  INTERRUPTED = 'Interrupted',
  PAUSED = 'Paused',
  PROCESSING = 'Processing',
  READY = 'Ready',
  SCHEDULED = 'Scheduled',
  TESTING = 'Testing',
  TO_VALIDATE = 'To validate',
  SENDING = 'Sending',
}

export enum MESSAGE_APP {
  CURRENT = 'current',
  ALL = 'all',
}

export enum MESSAGE_OWNER {
  ME = 'me',
  ALL = 'all',
}

export enum MESSAGE_TYPE_GROUP {
  INAPP = 'inapp',
  OUTAPP = 'outapp',
}

export const PLUGIN_ID_PREFIX = 'emma-plugin-';

export enum CLICK_MODE_TYPE {
  DEEPLINK = 'deeplink',
  CUSTOM_URL = 'customUrl',
  CHANGE_URL = 'changeUrl',
  TAP = 'tap',
}

export const PUSH_MESSAGE_MAX_LENGTH = 144;
export const PUSH_TITLE_MAX_LENGTH = 50;
